export const getSurveyAvatarBadge = (status, isFacilitation = false) => {
    let result = "";

    switch (status) {
        case "draft":
            result = isFacilitation ? "" : "warning";
            break;
        case "awaiting_approval":
            result = isFacilitation ? "review_self" : "review";
            break;
        case "review":
            result = isFacilitation ? "review_self" : "review";
            break;
        case "rejected":
            result = "error";
            break;
        case "completed":
            result = "checked";
            break;
        default:
            result = "";
            break;
    }

    return result;
};

export const surveyStatusMessage = (status, isFacilitation = false) => {
    let result = {};

    switch (status) {
        case "draft":
            result = isFacilitation
                ? {
                      severity: "info",
                      message: "In draft",
                  }
                : {
                      severity: "warning",
                      message: "Please add assessors and submit for approval",
                  };
            break;

        case "awaiting_approval":
            result = isFacilitation
                ? {
                      severity: "warning",
                      message: "Please review and approve list of assessors",
                  }
                : {
                      severity: "info",
                      message:
                          "Assessor list is awaiting approval from the Facilitator",
                  };
            break;

        case "open":
            result = {
                severity: "info",
                message: "In progress (awaiting responses)",
            };
            break;

        case "review":
            result = isFacilitation
                ? {
                      severity: "warning",
                      message: "Please review and release this report.",
                  }
                : {
                      severity: "info",
                      message: "Responses are being reviewed by Facilitator",
                  };
            break;

        case "rejected":
            result = {
                severity: "error",
                message: "survey rejected by Facilitator",
            };
            break;

        case "completed":
            result = { severity: "success", message: "Completed" };
            break;

        default:
            break;
    }

    return result;
};
